import React from "react";
import item2 from "../../assets/tools.svg";
import item3 from "../../assets/money.svg";
import items from "../../assets/w.svg";
import "./style.css";
import { Button } from "@chakra-ui/react";
import { Link } from "react-router-dom";
export default function Home() {
  return (
    <>
      <div className="position-relative text-center sm:pt-0 mx-auto  lg:pt-20   header  container-fluid row">
        <div className="col-lg-6 p-4 flex-col mx-auto">
          <h3 className="text-7xl lead head">
            Services à la demande en un clique.
          </h3>
          <p className="text-xl text-gray-600 -head my-2">
            Nous fournissons une plateforme qui facilite les demandes de
            services entre les particuliers et les techniciens disponibles dans
            votre zone
          </p>
          <div className="flex-col flex flex-wrap gap-3 mb-2 mx-auto">
            <Link to="/demand">
              <Button
                size="lg"
                height="48px"
                colorScheme="orange"
                className="flex pub gap-2 py-3 text-2xl"
                transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
              >
                <ion-icon name="construct-sharp" />
                <p className="text-2xl"> Je veux un Service</p>
              </Button>
            </Link>

            <Link to="/rejoindre">
              <Button
                size="lg"
                height="48px"
                colorScheme="gray"
                className="flex bg-gray-200 gap-2 py-3 text-2xl"
                transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
              >
                <ion-icon name="ribbon-outline" />
                <p className="text-2xl"> J'offre des Services</p>
              </Button>
            </Link>
          </div>
        </div>
        <div className="col-lg-6 ">
          <img
            src="./images/jens.jpg"
            alt="tools"
            className="w-full h-100 object-cover"
            srcset=""
          />
        </div>
      </div>
      <div className="flex my-8 space justify-center gap-3 flex-wrap row  mb-10 container  mx-auto justify-center">
        <h2 className="text-5xl font-semibold text-center text-orange-400">
          Nos atouts.
        </h2>
        <div className="col-lg-3">
          <div className="item mx-auto rounded-full sm:h-52 sm:w-52 bg-gray-100 p-3">
            <img
              src="./images/tim.svg"
              className="p-3 m-auto"
              alt="tools"
              srcset=""
            />
          </div>
          <p className="mt-2 head text-2xl  text-center">
            Vous allez profiter de 90% de votre temps en nous laissant
            travailler
          </p>
        </div>
        <div className="col-lg-3">
          <div className="item mx-auto rounded-full sm:h-52 sm:w-52 bg-gray-100 p-3">
            <img src={item2} className="p-3 m-auto" alt="tools" srcset="" />
          </div>
          <p className="mt-2 head text-2xl  text-center">
            Nous utilisons les meilleurs outils du marche
          </p>
        </div>
        <div className="col-lg-3">
          <div className="item mx-auto rounded-full lg:h-52 lg:w-52 bg-gray-100 p-3">
            <img src={item3} className="p-3  m-auto" alt="" srcset="" />
          </div>
          <p className="mt-2 head text-2xl  text-center">
            Gagnez et Economisez jusqu'à 10% de gain en plus
          </p>
        </div>
      </div>
      <div className="w-full lg:w-3/4 justify-center mx-auto  bg-gray-100 flex-col text-center py-5 flex justify-center items-center">
        <div className="mx-auto flex md:2/4 justify-center items-center flex-wrap">
          <p className="text-5xl head  text-whit mx-auto">
            Faites confiance à une equipe de professionelles
          </p>
          <div className="flex gap-2 mt-8 flex-wrap -auto ">
            <a
              href="/inscription"
              className="btn btn-block border bg-orange-500 hover:bg-orange-600 text-white-   font-bold text-2xl"
            >
              Creer un compte
            </a>

            <a
              href="/demand"
              className="btn btn-block bg-green-500 hover:bg-green-600 font-bold text-2xl"
            >
              Commander un service{" "}
            </a>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap w-full  mx-auto position-relative  gap-2 justify-content-center text-center items-center-">
        <img src={items} className="lg:w-2/4 w-full" alt="pub" />
        <div className="flex-col w-full mt-5 position-absolute lg:position-static lg:top-30 lg:bottom-20 top--0 bottom-10 lg:w-1/3">
          <h3 className="lg:text-5xl text-5xl text-orange-400 font-semibold">
            Nous travaillons pour vous à moindre coût.
          </h3>
        </div>
      </div>
    </>
  );
}
